import React from "react";

const Offers = () => {
  return (
    <section className="content mb-5">
      <div className="container-fluid">
        <div className="row titlepad">
          <div className="col-md-12">
            <div className="mt-3 mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>

            <div className="row align-items-end">
              <div className="col-sm-9">
                <h4>Offers</h4>
                <p className="page-sub-head">Showing 1 to 10 of 57 list</p>
                <a
                  href="../vendor-admin/Offerdetails"
                  className="btn-md btn-primary d-inline-block"
                >
                  <i className="fa-solid fa-user-plus"></i> Add More
                </a>
                <a href="#" className="btn-md btn-info d-inline-block">
                  <i className="fa-regular fa-file-excel"></i> Export
                </a>
                <a
                  href="#"
                  data-toggle="modal"
                  data-target="#filter"
                  className="btn-md btn-dark d-inline-block"
                >
                  <i className="fa-solid fa-filter"></i> Filter
                </a>
              </div>
              <div className="col-md-3">
                <input
                  className="form-control searchinput"
                  type="text"
                  placeholder="Search Offers..."
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="table-responsive bg-white">
              <table
                className="table table-striped table-bordered admintable border-0"
                cellspacing="0"
                cellpadding="0"
              >
                <tbody>
                  <tr>
                    <th>#</th>
                    <th>Offer Type</th>
                    <th>Offer Name</th>
                    <th>Discount type</th>
                    <th>Discount value</th>
                    <th>Usage</th>
                    <th>Services</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>

                  <tr>
                    <td>1</td>
                    <td>Promotion</td>
                    <td>Carestyle Offer</td>
                    <td>Fixed</td>
                    <td>25</td>
                    <td>1/Person</td>
                    <td>Haircut, SPA</td>
                    <td>14-07-2023</td>
                    <td>17-07-2023</td>
                    <td>
                      <span className="badge bad-status badge-success">
                        Active
                      </span>
                    </td>
                    <td>
                      <a href="offer-detail.html" className="f-16 mr-1">
                        <i className="iconly-boldEdit"></i>
                      </a>
                      <a href="#" className="text-danger f-16">
                        <i className="iconly-boldDelete"></i>
                      </a>
                    </td>
                  </tr>

                  <tr>
                    <td>2</td>
                    <td>Coupon</td>
                    <td>Carestyle 20%</td>
                    <td>Percentage</td>
                    <td>25</td>
                    <td>2/Person</td>
                    <td>Haircut, SPA</td>
                    <td>14-07-2023</td>
                    <td>17-07-2023</td>
                    <td>
                      <span className="badge bad-status badge-danger">
                        InActive
                      </span>
                    </td>
                    <td>
                      <a href="offer-detail.html" className="f-16 mr-1">
                        <i className="iconly-boldEdit"></i>
                      </a>
                      <a href="#" className="text-danger f-16">
                        <i className="iconly-boldDelete"></i>
                      </a>
                    </td>
                  </tr>

                  <tr>
                    <td>3</td>
                    <td>Promotion</td>
                    <td>Carestyle 30%</td>
                    <td>Fixed</td>
                    <td>25</td>
                    <td>1/Person</td>
                    <td>Haircut, SPA</td>
                    <td>14-07-2023</td>
                    <td>17-07-2023</td>
                    <td>
                      <span className="badge bad-status badge-success">
                        Active
                      </span>
                    </td>
                    <td>
                      <a href="offer-detail.html" className="f-16 mr-1">
                        <i className="iconly-boldEdit"></i>
                      </a>
                      <a href="#" className="text-danger f-16">
                        <i className="iconly-boldDelete"></i>
                      </a>
                    </td>
                  </tr>

                  <tr>
                    <td>4</td>
                    <td>Promotion</td>
                    <td>Carestyle 40%</td>
                    <td>Percentage</td>
                    <td>25</td>
                    <td>3/Person</td>
                    <td>Haircut, SPA</td>
                    <td>14-07-2023</td>
                    <td>17-07-2023</td>
                    <td>
                      <span className="badge bad-status badge-success">
                        Active
                      </span>
                    </td>
                    <td>
                      <a href="offer-detail.html" className="f-16 mr-1">
                        <i className="iconly-boldEdit"></i>
                      </a>
                      <a href="#" className="text-danger f-16">
                        <i className="iconly-boldDelete"></i>
                      </a>
                    </td>
                  </tr>

                  <tr>
                    <td>5</td>
                    <td>Coupon</td>
                    <td>Carestyle 50%</td>
                    <td>Fixed</td>
                    <td>25</td>
                    <td>5/Person</td>
                    <td>Haircut, SPA</td>
                    <td>14-07-2023</td>
                    <td>17-07-2023</td>
                    <td>
                      <span className="badge bad-status badge-danger">
                        InActive
                      </span>
                    </td>
                    <td>
                      <a href="offer-detail.html" className="f-16 mr-1">
                        <i className="iconly-boldEdit"></i>
                      </a>
                      <a href="#" className="text-danger f-16">
                        <i className="iconly-boldDelete"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="pagination_rounded">
            <ul>
              <li>
                <a href="#" className="prev">
                  
                  <img src="/img/back.svg" />
                </a>
              </li>
              <li className="active">
                <a href="#">1</a>
              </li>
              <li className="hidden-xs">
                <a href="#">2</a>
              </li>
              <li className="hidden-xs">
                <a href="#">3</a>
              </li>
              <li className="visible-xs">
                <a href="#">...</a>
              </li>
              <li>
                <a href="#">32</a>
              </li>
              <li>
                <a href="#" className="next">
                  
                  <img src="/img/back.svg" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Offers;
